import { Component, OnInit, ChangeDetectionStrategy, Input } from '@angular/core';
import { ContentType } from '../error-prompt/error-prompt.component';

@Component({
  selector: 'mode-not-found',
  templateUrl: './not-found.component.html',
  styleUrls: ['./not-found.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class NotFoundComponent implements OnInit {
  errorTitle!: string;
  errorExplanation!: string;
  errorInstructions!: string;
  errorPrimaryActionLabel!: string;
  errorPrimaryActionTarget!: string;

  @Input()
  contentType: ContentType | undefined;

  constructor() {}

  ngOnInit(): void {
    this.errorTitle = 'We couldn’t find the Collection you’re looking for.';
    this.errorExplanation = `This usually happens when a Collection has been deleted. Try a new URL, or continue to Mode using the button below.`;
    this.errorInstructions = '';
    this.errorPrimaryActionLabel = 'Continue to your Mode homepage';
    this.errorPrimaryActionTarget = '/home/';
  }
}
